import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
//import axios from 'axios';
const Register= () => {
   
   const [fullName,setFullName] = useState('');
   const [email,setEmail] = useState('');
   const [userPass,setUserPass] = useState('');
   const [role,setRole] =useState('');
   const [errors,setErrors] =useState('');
   const navigate = useNavigate(); // For navigation
   /* useEffect(() => {
             // Add a class to the body when this component is mounted
             document.body.classList.remove('login-page'); // Remove class from <body> tag
             document.body.classList.add('register-page');
             // Cleanup function to remove class when the component is unmounted
             return () => {
               document.body.classList.remove('login-page'); // Remove the class on unmount
               document.body.classList.add('register-page');
             };
           }, []); */ // Empty dependency array ensures this effect runs only once (on mount)
   /* const passMatch =(e) => {
    e.preventDefault();
    if(!(userPass===e.target.value)) {
        document.getElementById("conPass").value="";
        document.getElementById("conPassError").innerHTML="Passwords do not match";
        document.getElementById("conPassError").style.display="block";
    }
    else {
        document.getElementById("conPassError").style.display="none";
    }
   } */
     /* const handleRegister =(e) => {
        e.preventDefault(); // Prevent form default behavior
        const formData=new FormData();
        formData.append("jsonData" , JSON.stringify({
            "fullName":fullName,
            "email":email,
            "userPass":userPass,
            "role":role
          }));
        const REST_API_BASE_URL = `http://localhost:8081/api/register`;
      const loginIn= (formData) => axios.post(REST_API_BASE_URL,formData);
      loginIn(formData)
        .then((response) => {
        window.alert(`Success! `+response.data);
          navigate("/login"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          setErrors(error);
          
          
        });
     }
    */
    return(
        <div class="container">

      <div class="auth-wrapper">

        <form >

          <div class="auth-box">
            <a href="index-2.html" class="auth-logo mb-4">
              <img src="assets/images/logo.jpg" alt="Webnet logo"/>
            </a>

            <h4 class="mb-4">Signup</h4>

            <div class="mb-3">
              <label class="form-label" for="name">Your name <span class="text-danger">*</span></label>
              <input type="text" id="name" class="form-control" placeholder="Enter your name"/>
            </div>

            <div class="mb-3">
              <label class="form-label" for="email">Your email <span class="text-danger">*</span></label>
              <input type="text" id="email" class="form-control" placeholder="Enter your email"/>
            </div>

            <div class="mb-3">
              <label class="form-label" for="pwd">Your password <span class="text-danger">*</span></label>
              <div class="input-group">
                <input type="password" id="pwd" class="form-control" placeholder="Enter password"/>
                <button class="btn btn-outline-secondary" type="button">
                  <i class="ri-eye-line text-primary"></i>
                </button>
              </div>
              <div class="form-text">
                Your password must be 8-20 characters long.
              </div>
            </div>

            <div class="mb-3 d-grid gap-2">
              <button type="submit" class="btn btn-primary">Signup</button>
              <a href="/login" class="btn btn-secondary">Already have an account? Login</a>
            </div>

          </div>

        </form>
      </div>
 </div>

    ); 
}
export default Register;
